import { createApi } from "@reduxjs/toolkit/query/react";

import { REQUESTS } from "utils/api";

import { baseQueryWithReAuth } from "./baseQuery";
import { ME_MOCK_DATA, MockUserInfo } from "./mocks/user.api.mock";
import { USE_MOCK_DATA } from "./mocks/constants";

export const userApi = createApi({
  reducerPath: "userQuery",
  tagTypes: ["User"],
  baseQuery: baseQueryWithReAuth,
  endpoints: (build) => ({
    getUser: build.query<MockUserInfo, string>({
      query: () => REQUESTS.users,
      providesTags: () => [{ type: "User", id: "LIST" }],
      transformResponse: (response) => {
        return USE_MOCK_DATA ? ME_MOCK_DATA : (response as MockUserInfo);
      },
    }),
    updateUser: build.mutation({
      query: (body) => ({
        url: `${REQUESTS.users}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["User"],
    }),
  }),
});

export const { useGetUserQuery, useUpdateUserMutation } = userApi;
